import React, { Component, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { faqList } from '../../actions/settings';

const FAQ = () => {
    const faq = useSelector((state) => state.faq)
    const dispatch = new useDispatch();

    useEffect(() => {
        const params = { page: 1, limit: 100 }
        dispatch(
            faqList(params, (res) => { }),
        )
    }, [])

    return (
        <div>
            <div className="logoBeeline">
                <img alt="logo" height={120} src={require('../../assets/images/newfile/Property 1=Variant2 (1).svg').default} />
            </div>
            <div className="container">
                <h1 style={{ textAlign: 'center', color: '#442580', fontWeight: 700 }}>
                    Frequently Asked Questions
                </h1>
                <div className="horizontalLine"></div>

                <div className="descrDiv">
                    <p style={{ textAlign: 'center', color: '#555555' }}>
                        Find all your questions and answers about the Climate Mobility App.
                    </p>
                </div>

                <div>
                    <div class="tabs demo">
                        {faq.list.map((item, index) => {
                            return (
                                <div>
                                    <input class="input" type="checkbox" id={index} />
                                    <label class="label" for={index}>
                                        {item.question}
                                    </label>

                                    <div class="content">
                                        <p dangerouslySetInnerHTML={{ __html: item.answer }}>

                                        </p>
                                    </div>
                                </div>
                            )
                        })}

                        {/* <input class="input" type="checkbox" id="title1" />
                        <label class="label" for="title1">
                            What information is required to create an account in the City of
                            Glendale app?
                        </label>

                        <div class="content">
                            <p>
                                To create an account, you&#39;ll need to provide your first and last
                                name, email, create a password following specific criteria, mobile
                                number, date of birth, gender, street address, city, state, and zip
                                code. Additionally, you&#39;ll need to check boxes confirming your
                                age, acceptance of terms and conditions, and the option to join a
                                group.
                            </p>
                        </div>

                        <input class="input" type="checkbox" id="title2" />
                        <label class="label" for="title2">
                            How do I activate my account after creating it?
                        </label>

                        <div class="content">
                            <p>
                                Once you&#39;ve created an account, an activation email will be sent
                                to you. Click on the link in the email, and it will redirect you to
                                the app with a confirmation message: &quot;Thank you for confirming
                                your email. Click here to log in.&quot;
                            </p>
                        </div>

                        <input class="input" type="checkbox" id="title3" />
                        <label class="label" for="title3">
                            What do I do if I forget my password?
                        </label>

                        <div class="content">
                            <p>
                                You can use the &quot;Forgot my password&quot; option on the login
                                page. Follow the prompts to reset your password.
                            </p>
                        </div>

                        <input class="input" type="checkbox" id="title4" />
                        <label class="label" for="title4">
                            Can I enable biometrics for login?
                        </label>

                        <div class="content">
                            <p>
                                Yes, upon your first login, the app will ask if you would like to
                                set up biometrics for future logins.
                            </p>
                        </div>

                        <input class="input" type="checkbox" id="title5" />
                        <label class="label" for="title5">
                            How do I plan a trip using the app?
                        </label>

                        <div class="content">
                            <p>
                                Navigate to the &quot;Home&quot; section, select &quot;Trip
                                Planning,&quot; choose your mode of transportation, input date,
                                time, starting point, and destination. Click &quot;Submit&quot; for
                                trip recommendations.
                            </p>
                        </div>

                        <input class="input" type="checkbox" id="title6" />
                        <label class="label" for="title6">
                            What are Hive Points, and how do I earn them?
                        </label>

                        <div class="content">
                            <p>
                                
                                Hive Points Shows your contribution to the reduction of emissions. You earn points when completing your trip on the beeline services using the app.
                            </p>
                        </div>

                        <input class="input" type="checkbox" id="title7" />
                        <label class="label" for="title7">
                            How do I contact customer support?
                        </label>

                        <div class="content">
                            <p>
                                You can contact us via phone at
                                <a href="tel:+1 (818) 548-3960"> (818) 548-3960</a>, email at&nbsp;
                                <a href="mailto:beeline@glendaleca.gov">beeline@glendaleca.gov</a>,
                                or use the Customer Report Form&nbsp;
                                <a href="https://www.glendaletransit.com/contact-us/customer-report-form">
                                    here.
                                </a>
                            </p>
                        </div>

                        <input class="input" type="checkbox" id="title8" />
                        <label class="label" for="title8">
                            Can I change my language preferences in the app?
                        </label>

                        <div class="content">
                            <p>
                                Yes, you can change your language preferences in the
                                &quot;Settings&quot; section, where options include English,
                                Armenian, and Spanish.
                            </p>
                        </div>

                        <input class="input" type="checkbox" id="title9" />
                        <label class="label" for="title9">
                            What information does the &quot;My Points&quot; section display?
                        </label>

                        <div class="content">
                            <p>
                                &quot;My Points&quot; displays your earned points for contributing
                                to the community and participating in the app. You can also redeem
                                points for various merchandise and services listed in the
                                &quot;Redeem Points&quot; section.
                            </p>
                        </div>
                        <input class="input" type="checkbox" id="title10" />
                        <label class="label" for="title10">
                            How can I view and submit real-time information on bus routes?
                        </label>

                        <div class="content">
                            <p>
                                Navigate to &quot;Realtime/Crowd Sourcing Information&quot; where
                                you can view buses, user comments, and submit information on next
                                bus stop arrival, capacity, cleanliness, and safety.
                            </p>
                        </div>
                        <input class="input" type="checkbox" id="title11" />
                        <label class="label" for="title11">
                        How do I redeem an item through the Climate Mobility Application?

                        </label>

                        <div class="content">
                            <p>
                                <b>
                            To redeem an item, follow these simple steps:
                            </b>
                            </p>
                           <p> <b>1.Visit the Outlet: </b>Head to the designated outlet affiliated with the merchant from whom you wish to redeem the item.</p>
                           <p><b>2.Merchant Assistance:</b> Once at the outlet, approach the merchant who will guide you through the redemption process.</p>
                           <p><b>3.Redemption Process:</b> Provide the mobile device from where the merchant can proceed to redeem the selected item on your behalf, ensuring a smooth and secure transaction.</p>
                           <p><b>4.Receive Redeemed Item:</b> After the redemption process, the merchant will provide you with the redeemed item. Confirm and inspect the item to ensure it meets your expectations.</p>
                           <p>By following these steps, you can seamlessly redeem items through the Glendale Bus Mobile Application, enjoying the benefits offered by our participating merchants.
                            </p>
                        </div> */}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FAQ
